// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__2FZW0","OrderButton":"BuildControls_OrderButton__D83CI","enable":"BuildControls_enable__3tTCJ"};